import { Box, Button, Checkbox, Container, Dialog, DialogActions, DialogContent, Divider, List, ListItem, ListItemText, Paper, Typography } from "@mui/material";
import { useParams } from "react-router-dom"
import TopBar from "../../components/TopBar";
import BottomBar from "../../components/BottomBar";
import { postDownload } from "../../util/api/downloadApi";
import { useDispatch } from "react-redux";
import { setError } from "../../actions/notificationActions";
import { useEffect, useState } from "react";

import { PRODUCT_NAMES, PRODUCT_IMAGES } from "../../components/ProductDetails";
import { LoggedOut } from "../../components/AccessControl";


const Embargo = ({ handleAgree }) => {
  const [agreed, setAgreed] = useState(false);

  return <Dialog maxWidth="md" sx={{ py: 4 }} open>
    <DialogContent>
      <Typography variant="h3" gutterBottom>
        Beta Program Terms of Service
      </Typography>
      <Typography variant="subtitle1" gutterBottom>
        Effective: August 9th, 2025
      </Typography>

      <Paper sx={{ p: 2, mb: 3 }}>
        <Typography variant="h6">Quick Summary</Typography>
        <List>
          <ListItem><ListItemText primary="Private access — Invite-only beta." /></ListItem>
          <ListItem><ListItemText primary="No public sharing until embargo lifts." /></ListItem>
          <ListItem><ListItemText primary="Provide feedback to improve the product." /></ListItem>
          <ListItem><ListItemText primary="Expect bugs — software may break or cause data loss." /></ListItem>
          <ListItem><ListItemText primary="Follow rules — misconduct may lead to removal." /></ListItem>
        </List>
      </Paper>

      <Box>
        <Typography variant="h6">1. Eligibility</Typography>
        <Typography>Participation is by invitation only and may be revoked at the WaveMind's discretion.</Typography>

        <Typography variant="h6" mt={2}>2. Purpose</Typography>
        <Typography>The Beta is provided to allow invited testers to preview the Beta Product and provide feedback.</Typography>

        <Typography variant="h6" mt={2}>3. Embargo & Confidentiality</Typography>
        <Typography>Do not share any details, screenshots, videos, or impressions until the full release or until WaveMind lifts the embargo in writing.</Typography>
        <Typography>All Beta-related information is confidential and proprietary.</Typography>

        <Typography variant="h6" mt={2}>4. Permitted Use</Typography>
        <Typography>You may use the Beta Product for personal, non-commercial testing only. No copying, distributing, modifying, reverse engineering, or derivative works.</Typography>

        <Typography variant="h6" mt={2}>5. Feedback</Typography>
        <Typography>By submitting feedback, you grant WaveMind rights to use it without obligation or compensation.</Typography>

        <Typography variant="h6" mt={2}>6. Risks & Disclaimer</Typography>
        <Typography>The Beta Product is pre-release and provided “AS IS” without warranties. Use at your own risk.</Typography>

        <Typography variant="h6" mt={2}>7. Termination</Typography>
        <Typography>WaveMind may terminate your access at any time. Upon termination, delete all copies of the Beta Product.</Typography>

        <Typography variant="h6" mt={2}>8. Governing Law</Typography>
        <Typography>These Terms are governed by the laws of the Netherlands.</Typography>
      </Box>

      <Divider sx={{ my: 3 }} />

      <Box display="flex" alignItems="center">
        <Checkbox checked={agreed} onChange={(e) => setAgreed(e.target.checked)} />
        <Typography>I agree to the Beta Program Terms of Service</Typography>
      </Box>
      <DialogActions>
        <Button variant="contained" color="primary" disabled={!agreed} onClick={handleAgree}>
          I Agree
        </Button>
      </DialogActions>
    </DialogContent>
  </Dialog>
}

const DownloadProviderPage = () => {
  const { os, productID } = useParams();


  const handleStart = () => {
    const url = `/downloadmanager/${productID}/${os}`
    const handle = window.open(url, "_blank");
    handle?.blur()
    window.focus();
    // postDownload(productID, os).then((response) => {
    //   const url = window.URL.createObjectURL(new Blob([response.data]));
    //   const link = document.createElement('a');
    //   link.href = url;
    //   link.setAttribute('download', response.headers?.["x-file-name"]); //or any other extension
    //   document.body.appendChild(link);
    //   link.click();
    // }).catch((e) => {
    //   dispatch(setError(e?.response?.data?.detail))
    // })
  }

  const handleExtraDownload = (extraID) => {
    const url = `/downloads/${os}/${extraID}`
    const handle = window.open(url, "_blank");
    handle?.blur()
    window.focus();
  }

  const ProductSuggestion = () => {
    let productsToSuggest = ["rev-f-amplifier-suite", "distant-amplifier-suite"]

    const index = productsToSuggest.indexOf(productID);
    if (index > -1) { // only splice array when item is found
      productsToSuggest.splice(index, 1); // 2nd parameter means remove one item only
    }

    let randomElement = productsToSuggest[Math.floor(Math.random() * productsToSuggest.length)];

    return <div>
      <Box sx={{ display: "flex", width: "100%", justifyContent: "center", alignItems: "center" }}>
        <img style={{ width: "500px" }} src={PRODUCT_IMAGES[randomElement]} />
      </Box>
      <Typography variant="h4">While you're waiting, have you tried {PRODUCT_NAMES[randomElement]} yet?</Typography>

      <Box sx={{ display: "flex", justifyContent: "center", alignItems: "center", flexDirection: "row", gap: 4 }}>
        <Button onClick={() => window.open(`/product/${randomElement}`, "_blank")} sx={{ mt: 2 }} variant="contained">More Info</Button>
        <Button onClick={() => handleExtraDownload(randomElement)} sx={{ mt: 2 }} variant="contained">Try it now for free</Button>
      </Box>
    </div>
  }

  return <div
    style={{ minHeight: "100vh", display: "flex", flexDirection: "column", background: "radial-gradient(circle, rgb(204, 204, 214) 0%, rgb(86, 86, 105) 100%)" }}
  >
    <TopBar />
    <Box
      sx={{
        backgroundSize: "cover",
        position: "relative",
        flex: 100,
        width: "100%",
        alignItems: "center",
        justifyContent: "center",
        textAlign: "center",
        display: "flex",
        flexDirection: "column",
        color: "black",
        minHeight: "100vh"
      }}
    >
      {<Typography variant="h3">Your download for {PRODUCT_NAMES[productID]} will start soon, enjoy!</Typography>}
      {<Button onClick={handleStart} sx={{ color: "black", mb: 10 }}>Click here if it does not start automatically</Button>}
      {<ProductSuggestion />}


      {<iframe style={{ display: "none" }} src={`/downloadmanager/${productID}/${os}`} />}
      {/* {productID === "dd-amplifier-suite" && <Embargo handleAgree={handleStart} />} */}
    </Box>

    <BottomBar />

  </div>
}

export default DownloadProviderPage
